import React from 'react'

import grungetdtr2 from '../assets/grungetdtr2.png'

const TDTR = () => {
    return (
        <div style={{ width: '100vw', height: '350px', backgroundColor: '#000', position: 'relative', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <div style={{ width: '240px', height: '240px' }}>
                <img src={ grungetdtr2 } style={{ width: '100%' }} />
            </div>
        </div>
    )
}

export default TDTR